import React, {Component} from 'react'

export default class OnasTekst extends Component {

    render() {
        return <div class="text-left" style={{margin: 50}}>
            <p>Zdobyliśmy wiele prestiżowych nagród za dynamiczny rozwój i wspaniałe reprezentowanie regionu wysokim
                poziomem
                usług przewozowych.Jesteśmy przewoźnikiem pewnym, z dużym kapitałem, stabilną pozycją, nowym
                taborem, gwarantujemy najlepsze i najwyższe pakiety ubezpieczeń &#8211; wynajmując nas masz pewność
                rzetelności wykonanych usług. Firma została założona w 2000 roku.</p>
            <p>Gwarantujemy stosowny stan prawny autobusów w transporcie krajowym oraz międzynarodowym, oraz bardzo
                dobry stan techniczny autobusów serwisowanych w Autoryzowanych Stacjach Obsługi. Nasi Kierowcy mają
                wieloletnie doświadczenie w przewozach osobowych oraz posiadają wymagane kwalifikacje i dokumenty
                potwierdzające ich spełnianie. Priorytetem jest dla nas bezpieczeństwo przewozu, zadowolenie
                pasażerów, przestrzeganie przepisów dotyczących prędkości i czasu pracy kierowcy.</p>
            <p>Nasza firma nieprzerwanie od 2010 roku uczestniczy w programie Rzetelna Firma.</p>
            <p className="text-center"><a href="https://wizytowka.rzetelnafirma.pl/VFZC2SZQ/1"><img
                class="alignnone size-full wp-image-1478"
                src="/files/marcel-image/onas/rzetelna.jpg" alt="rzetelna" width="300"
                height="158"/></a></p>
            <hr/>
            <p>Posiadamy ochronę prawną w zakresie bezpieczeństwa przetwarzanych przez nas danych osobowych, którą
                zapewnia firma SecurePro. Gwarantujemy naszym klientom najwyższy poziom bezpieczeństwa w tym
                zakresie.</p>
            <h3 className="text-center"><a href="http://securepro.pl/"><img
                class="alignnone size-full wp-image-1482"
                src="/files/marcel-image/onas/secure2.jpg"
                alt="secure2" width="300" height="75"/></a></h3>
            <hr/>
            <h3>Regularne linie autobusowe</h3>
            <p>Obecnie Marcel obsługuje <strong>9 linii regularnych</strong> oraz posiada zezwolenia na regularne
                linie autobusowe do miast:</p>
            <ul class='typo_tick'>
                <li><span class='icon'></span>Kraków – Rzeszów</li>
                <li><span class='icon'></span>Kielce &#8211; Opatów- Rzeszów</li>
                <li><span class='icon'></span>Krosno – Rzeszów</li>
                <li><span class='icon'></span>Stalowa Wola – Nisko - Rzeszów</li>
                <li><span class='icon'></span>Tarnobrzeg – Kolbuszowa &#8211; Rzeszów</li>
                <li><span class='icon'></span>Mielec – Kolbuszowa &#8211; Rzeszów</li>
                <li><span class='icon'></span>Jawornik Polski – Rzeszów</li>
                <li><span class='icon'></span>Dębica – Ropczyce &#8211; Rzeszów</li>
                <li><span class='icon'></span>Sanok – Brzozów &#8211; Rzeszów</li>
            </ul>
            <hr/>
            <p>Zarządzający firmą uzyskał <strong>certyfikat kompetencji zawodowych</strong> w krajowym transporcie
                drogowym osób o nr 01574/F1/02, a firma posiada</p>
            <div class="typo_one-third">
                <ul class='typo_tick'>
                    <li><span class='icon'></span><strong>Licencję o nr 0047443</strong> na wykonywanie krajowego
                        transportu drogowego w zakresie przewozu osób wydaną przez Starostwo Powiatowe w Rzeszowie
                    </li>
                </ul>
                <center><a href="/files/marcel-image/onas/004.jpg" rel="lightbox"><img
                    class="aligncenter wp-image-916 size-large"
                    src="/files/marcel-image/onas/004.jpg" alt="" style={{maxWidth: '40%'}}/></a></center>
            </div>
            <div class="typo_one-third">
                <ul class='typo_tick'>
                    <li><span class='icon'></span><strong>Licencję o nr OU – 002641</strong> na wykonywanie
                        międzynarodowego transportu drogowego w zakresie przewozu osób wydaną przez Ministra Transportu.
                    </li>
                </ul>
                <center><a href="/files/marcel-image/onas/003.jpg" rel="lightbox"><img
                    class="aligncenter wp-image-915 size-large"
                    src="/files/marcel-image/onas/003.jpg" alt="" style={{maxWidth: '40%'}}/></a></center>
                <br/>
            </div>
            <div class="typo_one-third">
                <ul class='typo_tick'>
                    <li><span class='icon'></span><strong>Certyfikat kompetencji zawodowych w drogowym transporcie osób
                        nr 00324/TO/12</strong> wydanym przez Instytut Transportu Samochodowego w imieniu Wspólnoty
                        Europejskiej
                    </li>
                </ul>
                <center><a href="/files/marcel-image/onas/006.jpg"><img
                    class="aligncenter size-large wp-image-918"
                    src="/files/marcel-image/onas/006.jpg" alt="" style={{maxWidth: '40%'}}/></a></center>
                <br/>
            </div>
            <div class="typo_one-third">
                <ul class='typo_tick'>
                    <li><span class='icon'></span><strong>Certyfikat kompetencji zawodowych w krajowym transporcie
                        drogowym nr 01574/F1/02</strong> wydanym przez Instytut Transportu Samochodowego.
                    </li>
                </ul>
                <center><a href="/files/marcel-image/onas/005.jpg" target="_blank"><img
                    class="aligncenter wp-image-917 size-large"
                    src="/files/marcel-image/onas/005.jpg" alt="" style={{maxWidth: '40%'}}/></a></center>
                <br/>
            </div>
        </div>

    }

}



// WEBPACK FOOTER //
// ./src/components/home/homeComponents/firmaComponents/OnasTekst.js